import { Link, NavLink, Outlet } from "react-router-dom";
import logo from "../assets/logo.jpg";
import { useCartCount } from "../state/cart";
import { useQuery } from "@tanstack/react-query";
import { fetchCategories } from "../api/categories";
import LoadingIcon from "../components/LoadingIcon";
import { useState, useEffect } from "react";
import { UrlTableBootstrap } from "../utils/urlTableBootstrap";

export function Layout() {
  const count = useCartCount();
  const [openMenu, setOpenMenu] = useState(false);

  const { data: CATEGORIES, isLoading } = useQuery({
    queryKey: ["categories"],
    queryFn: fetchCategories,
  });

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") setOpenMenu(false);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  return (
    <div className="flex min-h-screen">
      <header className="h-14 flex justify-between items-center p-4 border-b bg-white fixed top-0 left-0 right-0 z-[60]">
        <div className="flex items-center gap-2">
          <button
            className="sm:hidden mr-1 p-2 -ml-2"
            onClick={() => setOpenMenu((v) => !v)}
            aria-label="Открыть меню"
          >
            <svg
              className="w-6 h-6 text-gray-700"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M4 6h16M4 12h16M4 18h16"
              />
            </svg>
          </button>

          <Link to="/" className="inline-flex items-center">
            <img src={logo} alt="Логотип" className="h-9 w-auto" />
          </Link>
        </div>

        <Link to="/cart" className="relative" aria-label="Открыть корзину">
          <svg
            viewBox="0 0 24 24"
            className="w-7 h-7 text-gray-700"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M2.25 2.25h1.5l1.59 9.546A2.25 2.25 0 007.57 13.5h9.86a2.25 2.25 0 002.23-1.704l1.34-6.03H6.375"
            />
            <path d="M9 20.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm7.5 0a.75.75 0 11-1.5 0 .75.75 0 011.5 0z" />
          </svg>
          <span className="absolute -top-1 -right-1 w-5 h-5 bg-[#FFB701] text-white text-[11px] rounded-full flex items-center justify-center">
            {count}
          </span>
        </Link>
      </header>

      <aside className="hidden sm:flex sm:flex-col fixed top-14 left-0 bottom-0 w-36 border-r bg-white overflow-y-auto">
        {isLoading ? (
          <LoadingIcon />
        ) : (
          <nav className="flex flex-col">
            <NavLink
              to={`/`}
              className={({ isActive }) =>
                `px-4 py-3 text-sm transition-colors ${
                  isActive
                    ? "font-semibold border-b-2 border-yellow-400 text-black"
                    : "text-gray-700 hover:text-black"
                }`
              }
            >
              Все
            </NavLink>
            {CATEGORIES &&
              CATEGORIES.map((c) => (
                <NavLink
                  key={c._id}
                  to={`/category/${c._id}`}
                  className={({ isActive }) =>
                    `px-4 py-3 text-sm transition-colors ${
                      isActive
                        ? "font-semibold border-b-2 border-yellow-400 text-black"
                        : "text-gray-700 hover:text-black"
                    }`
                  }
                >
                  {c.name}
                </NavLink>
              ))}
          </nav>
        )}
      </aside>

      {openMenu && (
        <div
          className="fixed inset-0 bg-black/30 z-40 sm:hidden"
          onClick={() => setOpenMenu(false)}
          aria-hidden="true"
        />
      )}

      <aside
        className={`fixed top-14 left-0 bottom-0 w-64 border-r bg-white z-50 sm:hidden
          transform transition-transform duration-300
          ${openMenu ? "translate-x-0" : "-translate-x-full"}`}
        aria-hidden={!openMenu}
      >
        {isLoading ? (
          <LoadingIcon />
        ) : (
          <nav className="flex flex-col">
            {CATEGORIES &&
              CATEGORIES.map((c) => (
                <NavLink
                  key={c._id}
                  to={`/category/${c._id}`}
                  onClick={() => setOpenMenu(false)}
                  className={({ isActive }) =>
                    `px-4 py-3 text-sm transition-colors ${
                      isActive
                        ? "font-semibold border-b-2 border-yellow-400 text-black"
                        : "text-gray-700 hover:text-black"
                    }`
                  }
                >
                  {c.name}
                </NavLink>
              ))}
          </nav>
        )}
      </aside>

      <main className="ml-0 sm:ml-36 flex-1 pt-14 p-3 flex flex-col">
        <div className="flex-1">
          <Outlet />
        </div>

        <footer className="border-t bg-white text-xs text-gray-600 mt-6 px-4 py-3">
          <div className="flex flex-col gap-2 text-center">
            <a
              href="https://xlfood.ru/Политика%20в%20отношении%20обработки%20персональных%20данных%20XL.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="underline hover:text-gray-800"
            >
              Политика конфиденциальности
            </a>
            <div>
              <p>ИП Шиханцев Роман Владимирович</p>
              <p>
                Юридический адрес компании: г. Красноярск, улица Парижской
                Коммуны, д. 31
              </p>
            </div>
          </div>
        </footer>
      </main>

      {/* <TablePersonsModal maxTables={5} /> */}
      <UrlTableBootstrap />
    </div>
  );
}
